import React, { CSSProperties, ReactNode } from "react";
import styled from "styled-components";

import Tooltip from "../tooltip/Tooltip";

import Text from "./Text";

const StyledCircle = styled.div<{ size?: "small" | "normal" }>`
  display: inline-block;
  text-transform: uppercase;
  text-align: center;
  font-family: var(--font-family-sans-serif);

  border-radius: var(--badge-size);

  height: var(--badge-size);
  width: var(--badge-size);
  line-height: var(--badge-size);
  font-size: calc(var(--badge-size) * 0.7);
`;

const StyledWrapper = styled.div`
  display: inline-flex;
  gap: 0.5rem;

  ${Text.Body} {
    line-height: 2.1rem;
  }
`;

type Props = {
  label?: ReactNode;
  tooltip?: string;
  letter: string;
  className?: string;
  style?: CSSProperties;
};

const _RoundBadge = ({ label, tooltip, letter, ...props }: Props) => (
  <Tooltip tip={tooltip} disableHide={tooltip == null} placement="top">
    <StyledWrapper {...props}>
      <StyledCircle title={tooltip}>{letter}</StyledCircle>
      {label && <Text.Body>{label}</Text.Body>}
    </StyledWrapper>
  </Tooltip>
);

_RoundBadge.Circle = StyledCircle;

const RoundBadge = styled(_RoundBadge)`
  --badge-size: 2.1rem;
`;

export default RoundBadge;
